import { useQuery } from '@tanstack/react-query'
import { OTP_PROVIDER_QUERY_KEYS } from '@/modules/otp-provider/constants'
import { OtpProviderService } from '@/modules/otp-provider/api/services'
import type { paths } from '@/schema'

type OtpProvidersResponse =
	paths['/api/admin/otp-provider']['get']['responses']['200']['content']['application/json']

const useQueryGetOtpProviders = () => {
	return useQuery<OtpProvidersResponse>({
		queryKey: OTP_PROVIDER_QUERY_KEYS.PROVIDERS.LIST(),
		queryFn: () => OtpProviderService.getOtpProviders(),
	})
}

export default useQueryGetOtpProviders
